import type { Goal } from "instantdb/types";

export const SLEEP_GOALS: Partial<Goal>[] = [
  {
    id: "build-better-sleep-habits",
    symbol: "🌙",
    title: "Build Better Sleep Habits",
    description: "Create a simple routine to help you sleep better",
  },
  {
    id: "create-a-sleep-friendly-bedroom",
    symbol: "🛏️",
    title: "Create a Sleep-Friendly Bedroom",
    description: "Make small changes to improve your sleep environment",
  },
  {
    id: "develop-a-bedtime-routine",
    symbol: "⏰",
    title: "Develop a Bedtime Routine",
    description: "Create simple habits to help you wind down before sleep",
  },
];
